<div class="container">
    <div
        aria-live="polite"
        aria-atomic="true"
        class="sr-only"
    >{{ selectedGoalPlan ? (('Selected' | translate: {Default: 'Selected'}) + ': ' + selectedGoalPlan.name + (selectedGoalPlan.overallStatus === 'reviewed' ? ', ' + translate.instant('Reviewed') : selectedGoalPlan.overallStatus === 'needsReview' ? ', ' + translate.instant('NeedsInput') : '')) : '' }}</div>

    <div class="left goal-plans">
        <h3 appLocalizationPopupDirective localizationCode="Review-GoalPlans">
            {{ 'Review-GoalPlans' | translate: {Default: 'Goal Plans'} }}
        </h3>

        <mat-list role="listbox" [attr.aria-label]="'Review-GoalPlans' | translate: {Default: 'Goal Plans'}">
            <mat-list-item *ngIf="review.goalPlans === null || review.goalPlans.length === 0">
                <span appLocalizationPopupDirective localizationCode="Review-NoGoalPlans">
                    {{ 'Review-NoGoalPlans' | translate: {Default: 'No Goal Plans'} }}
                </span>
            </mat-list-item>
            
            <ng-container *ngFor="let goalPlan of review.goalPlans; let last = last">
                <mat-list-item
                    role="option"
                    [attr.aria-selected]="selectedGoalPlan.id == goalPlan.id"
                    [attr.tabindex]="selectedGoalPlan.id == goalPlan.id ? 0 : -1"
                    [attr.aria-label]="goalPlan?.name + (goalPlan.overallStatus === 'reviewed' ? ', ' + translate.instant('Reviewed') : goalPlan.overallStatus === 'needsReview' ? ', ' + translate.instant('NeedsInput') : '') + (selectedGoalPlan.id == goalPlan.id ? ', ' + ('Selected' | translate: {Default: 'Selected'}) : '')"
                    [ngClass]="{
                        'selected-goal-plan': selectedGoalPlan.id == goalPlan.id
                    }"
                    appPreventDoubleClick (throttledClick)="selectedGoalPlan = goalPlan"
                    (keydown.enter)="selectedGoalPlan = goalPlan"
                    (keydown.space)="selectedGoalPlan = goalPlan; $event.preventDefault()"
                    (keydown.arrowdown)="navigateGoalPlan($event, goalPlan, 'down')"
                    (keydown.arrowup)="navigateGoalPlan($event, goalPlan, 'up')"
                >
                    <div class="top">
                        <div matListItemTitle>
                            {{goalPlan?.name}}
                        </div>

                        <mat-icon *ngIf="goalPlan.overallStatus === 'reviewed'" class="complete material-icons-outlined" [matTooltip]="translate.instant('Reviewed')" [attr.aria-label]="translate.instant('Reviewed')">check_circle</mat-icon>
                        <mat-icon *ngIf="goalPlan.overallStatus === 'needsReview'" class="need-input material-icons-outlined" [matTooltip]="translate.instant('NeedsInput')" [attr.aria-label]="translate.instant('NeedsInput')">feedback</mat-icon>

                    </div>
                    <div matListItemLine class="weight" *ngIf="goalPlan?.weight">
                        {{ 'Weight' | translate: {Default: 'Weight'} }} - {{ calculateSliderPercentage( goalPlan?.weight, 1 ) }}% <mat-progress-bar mode="determinate" [value]="calculateSliderPercentage( goalPlan?.weight, 1 )" aria-hidden="true"></mat-progress-bar>
                    </div>
                </mat-list-item>

                <mat-divider *ngIf="!last"></mat-divider>
            </ng-container>
        </mat-list>
    </div>
    <div class="right goals">

        <mat-tab-group class="mat-tab-group" *ngIf="selectedGoalPlan" setColor="primaryColour" (selectedTabChange)="onTabChange($event)">

            <mat-tab>
                <ng-template mat-tab-label>
                  <div class="mat-tab-header" appLocalizationPopupDirective localizationCode="Review-Goals">
                    {{ 'Review-Goals' | translate: {Default: 'Goals'} }}

                    <mat-icon *ngIf="selectedGoalPlan.goalsStatus === 'reviewed'" class="complete material-icons-outlined" [matTooltip]="translate.instant('Reviewed')" [attr.aria-label]="translate.instant('Reviewed')">check_circle</mat-icon>
                    <mat-icon *ngIf="selectedGoalPlan.goalsStatus === 'needsReview'" class="need-input material-icons-outlined" [matTooltip]="translate.instant('NeedsInput')" [attr.aria-label]="translate.instant('NeedsInput')">feedback</mat-icon>
                  </div>
                </ng-template>
  
                <ng-container *ngIf="selectedGoalPlan?.goals === null || selectedGoalPlan?.goals.length === 0; else showGoals">
                    <div class="no-goals">
                        <div appLocalizationPopupDirective localizationCode="Review-NoGoals">{{ 'Review-NoGoals' | translate: {Default: 'No Goals For This Goal Plan'} }}</div>
                    </div>
                </ng-container>
                <ng-template #showGoals>
                    <mat-expansion-panel *ngFor="let goal of selectedGoalPlan.goals" class="goal">
                        <mat-expansion-panel-header
                            [attr.aria-label]="goal.objective + (goal.status === 'reviewed' ? ', ' + translate.instant('Reviewed') : goal.status === 'needsReview' ? ', ' + translate.instant('NeedsInput') : '')"
                        >
                            <mat-panel-title>
                                {{goal.objective}}
                            </mat-panel-title>
                            <mat-panel-description>
                                <div class="k-flex-grow"></div>
        
                                <!-- <mat-icon *ngIf="calculateSliderPercentage( goal.percentageComplete, 1 ) === 100" class="goal-complete material-icons-outlined">check_circle</mat-icon> -->
                                <ng-container></ng-container>
        
                                <mat-icon *ngIf="goal.status === 'reviewed'" class="complete material-icons-outlined" [matTooltip]="translate.instant('Reviewed')" aria-hidden="true">check_circle</mat-icon>
                                <mat-icon *ngIf="goal.status === 'needsReview'" class="need-input material-icons-outlined" [matTooltip]="translate.instant('NeedsInput')" aria-hidden="true">feedback</mat-icon>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
        
                        <ng-template matExpansionPanelContent>
                            <dl class="goal-details">
                                <div>
                                    <dt class="label">{{getLabel('tfi_PEgDescription')}}</dt>
                                    <dd class="value">
                                        {{goal.description}}
                                    </dd>
                                </div>

                                <div>
                                    <dt class="label">{{getLabel('tfi_PEgGoalType')}}</dt>
                                    <dd class="value">
                                        {{goal.goalType?.name}}
                                    </dd>
                                </div>
        
                                <div>
                                    <dt class="label">{{getLabel('tfi_PEgPercentageComplete')}}</dt>
                                    <dd class="value">
                                        <div class="percentage-column">
                                            <span class="percentage-value" *ngIf="goal.percentageComplete !== null">
                                                {{ calculateSliderPercentage( goal.percentageComplete, 1 ) }}%
                                            </span>
                                            <mat-progress-bar setColor="primaryColour" mode="determinate" [value]="calculateSliderPercentage( goal.percentageComplete, 1 )" aria-hidden="true"></mat-progress-bar>
                                        </div>
                                    </dd>
                                </div>
        
                                <div>
                                    <dt class="label">{{getLabel('tfi_PEgWeight')}}</dt>
                                    <dd class="value">
                                        <div class="percentage-column">
                                            <span class="percentage-value" *ngIf="goal.weight !== null">
                                                {{ calculateSliderPercentage( goal.weight, 1 ) }}%
                                            </span>
                                            <mat-progress-bar setColor="primaryColour" mode="determinate" [value]="calculateSliderPercentage( goal.weight, 1 )" aria-hidden="true"></mat-progress-bar>
                                        </div>
                                    </dd>
                                </div>
        
                                <div>
                                    <dt class="label">{{getLabel('tfi_PEgExpectedCompletionDate')}}</dt>
                                    <dd class="value">
                                        {{goal.expectedCompletionDate | date:'mediumDate'}}
                                    </dd>
                                </div>
        
                                <div>
                                    <dt class="label">{{getLabel('tfi_PEgActualCompletionDate')}}</dt>
                                    <dd class="value">
                                        {{goal.actualCompletionDate | date:'mediumDate'}}
                                    </dd>
                                </div>
        
                            </dl>
        
                            <div class="reviews" *ngIf="goal?.reviews?.length > 0">
                                <h4 class="header" appLocalizationPopupDirective localizationCode="Reviews">
                                    {{ 'Reviews' | translate: {Default: 'Reviews'} }}
                                </h4>
                                <ng-container *ngIf="goal?.reviews === null || goal?.reviews?.length === 0; else showReviews">
                                    <div class="no-reviews" appLocalizationPopupDirective localizationCode="Review-NoGoalReviews">
                                        <div>{{ 'Review-NoGoalReviews' | translate: {Default: 'No Reviews For this Goal'} }}</div>
                                    </div>
                                </ng-container>
                                <ng-template #showReviews>
                                    <div *ngFor="let review of goal.reviews; let last = last" class="review">
                                        <ng-container *ngIf="showReview(review)">
                                            <app-review-goal-review
                                                [review]="review"
                                                [settings]="settings"
                                                [goalPlan]="selectedGoalPlan"
                                                [goalId]="goal?.id"
                                                [goalTypeId]="goal?.goalType?.id"
                                                (saveReview)="saveGoalReview.emit($event)"
                                            ></app-review-goal-review>
                                            <mat-divider *ngIf="!last"></mat-divider>
                                        </ng-container>
                                    </div>
                                </ng-template>
                            </div>

                            <div class="child-goals" *ngIf="goal.childGoals !== undefined && goal.childGoals.length > 0">
                                <h6 appLocalizationPopupDirective localizationCode="Review-ChildGoals">
                                    {{ 'Review-ChildGoals' | translate: {Default: 'Child Goals'} }}
                                </h6>

                                <mat-expansion-panel *ngFor="let childGoal of goal.childGoals; let first = first" [expanded]="first" class="goal">
                                    <mat-expansion-panel-header
                                        [attr.aria-label]="childGoal.objective + (childGoal.status === 'reviewed' ? ', ' + translate.instant('Reviewed') : childGoal.status === 'needsReview' ? ', ' + translate.instant('NeedsInput') : '')"
                                    >
                                        <mat-panel-title>
                                            {{childGoal.objective}}
                                        </mat-panel-title>
                                        <mat-panel-description>
                                            <div class="k-flex-grow"></div>
                    
                                            <!-- <mat-icon *ngIf="calculateSliderPercentage( goal.percentageComplete, 1 ) === 100" class="goal-complete material-icons-outlined">check_circle</mat-icon> -->
                                            <ng-container></ng-container>
                    
                                            <mat-icon *ngIf="childGoal.status === 'reviewed'" class="complete material-icons-outlined" [matTooltip]="translate.instant('Reviewed')" aria-hidden="true">check_circle</mat-icon>
                                            <mat-icon *ngIf="childGoal.status === 'needsReview'" class="need-input material-icons-outlined" [matTooltip]="translate.instant('NeedsInput')" aria-hidden="true">feedback</mat-icon>
                                        </mat-panel-description>
                                    </mat-expansion-panel-header>
                    
                                    <ng-template matExpansionPanelContent>
                                        <dl class="goal-details">
                                            <div>
                                                <dt class="label">{{getLabel('tfi_PEgDescription')}}</dt>
                                                <dd class="value">
                                                    {{childGoal.description}}
                                                </dd>
                                            </div>

                                            <div>
                                                <dt class="label">{{getLabel('tfi_PEgGoalType')}}</dt>
                                                <dd class="value">
                                                    {{childGoal.goalType?.name}}
                                                </dd>
                                            </div>
                    
                                            <div>
                                                <dt class="label">{{getLabel('tfi_PEgPercentageComplete')}}</dt>
                                                <dd class="value">
                                                    <div class="percentage-column">
                                                        <span class="percentage-value" *ngIf="goal.percentageComplete !== null">
                                                            {{ calculateSliderPercentage( childGoal.percentageComplete, 1 ) }}%
                                                        </span>
                                                        <mat-progress-bar setColor="primaryColour" mode="determinate" [value]="calculateSliderPercentage( childGoal.percentageComplete, 1 )" aria-hidden="true"></mat-progress-bar>
                                                    </div>
                                                </dd>
                                            </div>
                    
                                            <div>
                                                <dt class="label">{{getLabel('tfi_PEgWeight')}}</dt>
                                                <dd class="value">
                                                    <div class="percentage-column">
                                                        <span class="percentage-value" *ngIf="goal.weight !== null">
                                                            {{ calculateSliderPercentage( childGoal.weight, 1 ) }}%
                                                        </span>
                                                        <mat-progress-bar setColor="primaryColour" mode="determinate" [value]="calculateSliderPercentage( childGoal.weight, 1 )" aria-hidden="true"></mat-progress-bar>
                                                    </div>
                                                </dd>
                                            </div>
                    
                                            <div>
                                                <dt class="label">{{getLabel('tfi_PEgExpectedCompletionDate')}}</dt>
                                                <dd class="value">
                                                    {{childGoal.expectedCompletionDate | date:'mediumDate'}}
                                                </dd>
                                            </div>
                    
                                            <div>
                                                <dt class="label">{{getLabel('tfi_PEgActualCompletionDate')}}</dt>
                                                <dd class="value">
                                                    {{childGoal.actualCompletionDate | date:'mediumDate'}}
                                                </dd>
                                            </div>
                    
                                        </dl>
                    
                                        <div class="reviews" *ngIf="childGoal?.reviews?.length > 0">
                                            <h6 class="header" appLocalizationPopupDirective localizationCode="Reviews">
                                                {{ 'Reviews' | translate: {Default: 'Reviews'} }}
                                            </h6>
                                            <ng-container *ngIf="childGoal?.reviews === null || childGoal?.reviews?.length === 0; else showReviews">
                                                <div class="no-reviews" appLocalizationPopupDirective localizationCode="Review-NoGoalReviews">
                                                    <div>{{ 'Review-NoGoalReviews' | translate: {Default: 'No Reviews For this Goal'} }}</div>
                                                </div>
                                            </ng-container>
                                            <ng-template #showReviews>
                                                <div *ngFor="let review of childGoal.reviews; let last = last" class="review">
                                                    <ng-container *ngIf="showReview(review)">
                                                        <app-review-goal-review
                                                            [review]="review"
                                                            [settings]="settings"
                                                            [goalPlan]="selectedGoalPlan"
                                                            [goalId]="childGoal?.id"
                                                            [goalTypeId]="childGoal?.goalType?.id"
                                                            (saveReview)="saveGoalReview.emit($event)"
                                                        ></app-review-goal-review>
                                                        <mat-divider *ngIf="!last"></mat-divider>
                                                    </ng-container>
                                                </div>
                                            </ng-template>
                                        </div>
                    
                                    </ng-template>
                                </mat-expansion-panel>
                            </div>

                        </ng-template>
                    </mat-expansion-panel>
                </ng-template>
            </mat-tab>

            <mat-tab class="goal-plan-reviews-tab" *ngIf="selectedGoalPlan?.reviews !== null && selectedGoalPlan?.reviews.length > 0">
                <ng-template mat-tab-label>
                    <div class="mat-tab-header" appLocalizationPopupDirective localizationCode="Review-RatingsAndComments">
                        {{ 'Review-RatingsAndComments' | translate: {Default: 'Ratings & Comments'} }}

                        <mat-icon *ngIf="selectedGoalPlan.reviewStatus === 'reviewed'" class="complete material-icons-outlined" [matTooltip]="translate.instant('Reviewed')" [attr.aria-label]="translate.instant('Reviewed')">check_circle</mat-icon>
                        <mat-icon *ngIf="selectedGoalPlan.reviewStatus === 'needsReview'" class="need-input material-icons-outlined" [matTooltip]="translate.instant('NeedsInput')" [attr.aria-label]="translate.instant('NeedsInput')">feedback</mat-icon>
                    </div>
                </ng-template>

                <h6 
                    *ngIf="selectedGoalPlan?.reviews === null || selectedGoalPlan?.reviews.length === 0" 
                    appLocalizationPopupDirective 
                    localizationCode="Review-NoReviews"
                    class="no-reviews"
                >
                    {{ 'Review-NoReviews' | translate: {Default: 'No reviews'} }}
                </h6>

                <div class="goal-plan-reviews">
                    <div *ngFor="let r of selectedGoalPlan?.reviews; let last = last">
                        <app-overall-rating-comment
                            class="review"
                            [reviewPlanId]="review?.reviewPlan?.id"
                            [review]="r"
                            [reviewerPermissions]="getReviewerGoalPlanPermissions(selectedGoalPlan?.id, r?.reviewedBy?.id)"
                            (saveReview)="goalPlanReviewSubmitted($event)"
                        ></app-overall-rating-comment>
                        <mat-divider *ngIf="!last"></mat-divider>
                    </div>
                </div>

            <!-- <app-review-goals-section [review]="review" (saveGoalReview)="saveGoalReview($event)"></app-review-goals-section> -->
            </mat-tab>
        </mat-tab-group>


    </div>
</div>
